import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a4baf33"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login_container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_header" }, " 로그인 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/login_intro.png",
  srcset: "/assets/image/login_intro@2x.png 2x,/assets/image/login_intro@3x.png 3x"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_body" }, [
  /*#__PURE__*/_createTextVNode(" 엔젤리그의 모든 기능을 사용하고"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 소중한 자산을 안전하게 관리할 수 있도록"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 본인인증 및 로그인을 진행해주세요 ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_noti deep_blue" }, " 본인인증은 단 한 번이면 되어요! ", -1))
const _hoisted_6 = {
  key: 1,
  class: "login_container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_header" }, " 본인 인증 진행 중 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/login_intro.png",
  srcset: "/assets/image/login_intro@2x.png 2x,/assets/image/login_intro@3x.png 3x"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_body" }, " 본인 인증 후 이동 됩니다. ", -1))
const _hoisted_10 = {
  key: 2,
  class: "login_container"
}
const _hoisted_11 = { class: "login_header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/richie_orange.png",
  srcset: "/assets/image/richie_orange@2x.png 2x,/assets/image/richie_orange@3x.png 3x"
}, null, -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 3,
  class: "account_container"
}
const _hoisted_15 = { class: "header" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 이메일 ", -1))
const _hoisted_18 = { class: "radio-container ion-text-left" }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_21 = {
  key: 4,
  class: "agree_container"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/big_check.png",
  srcset: "/assets/image/big_check@2x.png 2x,/assets/image/big_check@3x.png 3x"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 엔젤리그 서비스 이용약관 ", -1))
const _hoisted_24 = { class: "agreeAll" }
const _hoisted_25 = { class: "check-container" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 약관에 모두 동의 ")
const _hoisted_28 = { class: "agree" }
const _hoisted_29 = { class: "check-container" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 엔젤리그 ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("이용약관")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" , ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("개인정보 처리방침")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" ,")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("유료서비스 이용약관")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 동의 (필수) ")
const _hoisted_39 = { class: "agree" }
const _hoisted_40 = { class: "check-container" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 엔젤리그 소식, 신규 클럽딜 정보 수신 동의 (선택) ")
const _hoisted_43 = { class: "agree" }
const _hoisted_44 = { class: "check-container" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 카카오클립 조합가입 증명카드 수신 동의. 개인정보 제 3자 제공 동의 (선택) ")
const _hoisted_47 = {
  key: 5,
  class: "login_container"
}
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/blue_richie.png",
  srcset: "/assets/image/blue_richie@2x.png 2x,/assets/image/blue_richie@3x.png 3x",
  style: {"width":"100px"}
}, null, -1))
const _hoisted_51 = {
  key: 0,
  class: "inline_btn"
}
const _hoisted_52 = {
  key: 1,
  class: ""
}
const _hoisted_53 = {
  key: 2,
  class: ""
}
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 3,
  class: ""
}
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 4,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_left_top_logo = _resolveComponent("left-top-logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          (_ctx.checkProcessStatus('init'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_left_top_logo),
                _hoisted_2,
                _hoisted_3,
                _hoisted_4,
                _hoisted_5
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('identityCertifying'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_left_top_logo),
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('under_adult'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_left_top_logo),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.authInfoMessage.title), 1),
                _hoisted_12,
                _createElementVNode("div", {
                  class: "login_body",
                  innerHTML: _ctx.$filters.newLineToBr(_ctx.authInfoMessage.msg)
                }, null, 8, _hoisted_13)
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('duplicate_account'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_left_top_logo),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.authInfoMessage.title), 1),
                _createElementVNode("div", {
                  class: "body",
                  innerHTML: _ctx.$filters.newLineToBr(_ctx.authInfoMessage.msg)
                }, null, 8, _hoisted_16),
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.duplicateAccounts, (data, inx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: inx,
                    class: "select-account"
                  }, [
                    _createElementVNode("label", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chooseAccount) = $event)),
                        name: "chooseAccount",
                        type: "radio",
                        value: data.userId
                      }, null, 8, _hoisted_19), [
                        [_vModelRadio, _ctx.chooseAccount]
                      ]),
                      _hoisted_20,
                      _createTextVNode(" " + _toDisplayString(data.email), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('agree_need'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_left_top_logo),
                _hoisted_22,
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agreeAll) = $event)),
                      type: "checkbox",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAgreeAll && _ctx.toggleAgreeAll(...args)))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.agreeAll]
                    ]),
                    _hoisted_26,
                    _hoisted_27
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agrees.agreeTerms) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.agrees.agreeTerms]
                    ]),
                    _hoisted_30,
                    _hoisted_31,
                    _createVNode(_component_router_link, { to: "/agree-use" }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    }),
                    _hoisted_33,
                    _createVNode(_component_router_link, { to: "/agree-use" }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    }),
                    _hoisted_35,
                    _hoisted_36,
                    _createVNode(_component_router_link, { to: "/agree-use" }, {
                      default: _withCtx(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    }),
                    _hoisted_38
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agrees.agreeMarketing) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.agrees.agreeMarketing]
                    ]),
                    _hoisted_41,
                    _hoisted_42
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.agrees.agreeThirdparty) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.agrees.agreeThirdparty]
                    ]),
                    _hoisted_45,
                    _hoisted_46
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('regist_success'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createVNode(_component_left_top_logo),
                _createElementVNode("div", {
                  class: "regist-success",
                  innerHTML: _ctx.$filters.newLineToBr(_ctx.authInfoMessage.title)
                }, null, 8, _hoisted_48),
                _createElementVNode("div", {
                  class: "regist-success-header",
                  innerHTML: _ctx.$filters.newLineToBr(_ctx.authInfoMessage.msg)
                }, null, 8, _hoisted_49),
                _hoisted_50
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { translucent: "" }, {
        default: _withCtx(() => [
          (_ctx.checkProcessStatus('init'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("button", {
                  class: "left_btn",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.seeYa && _ctx.seeYa(...args)))
                }, " 다음에 할게요 "),
                _createElementVNode("button", {
                  class: "right_btn",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.doStart && _ctx.doStart(...args)))
                }, " 시작 ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('under_adult'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("button", {
                  class: "block_btn",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.seeYa && _ctx.seeYa(...args)))
                }, " 확인 ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('duplicate_account'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("button", {
                  disabled: !_ctx.chooseAccount,
                  class: "block_btn",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onClickConfirmEmail && _ctx.onClickConfirmEmail(...args)))
                }, " 확인 ", 8, _hoisted_54)
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('agree_need'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("button", {
                  disabled: !_ctx.agrees.agreeTerms,
                  class: "block_btn",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onClickAgree && _ctx.onClickAgree(...args)))
                }, " 확인 ", 8, _hoisted_56)
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('regist_success'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("button", {
                  class: "block_btn",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.simplePassword && _ctx.simplePassword(...args)))
                }, " 확인 ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}